module.exports = __webpack_public_path__ + "img/flowmeter-icon.af8adbb3.svg";